module.exports = __webpack_public_path__ + "static/img/2.435f80c.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/13/02/2.png
// module id = PU52
// module chunks = 2